import { prop, PropParser } from '@lib/style/theme';

const textSecondary = 'rgba(0, 0, 0, 0.54)';
const black = '#222222';
const white = '#ffffff';
const dark = '#37474f';
const grey = '#cfd8dc';
const lightGrey = '#f9f9f9';
const mediumGrey = '#889195';
const blue = '#03a9f4';
const lightBlue = '#80D8FF';
const lighterBlue = '#e1f5fe';
const green = '#4caf50';
const yellow = '#fdd835';
const red = '#e4002b';
const inactive = '#999999';
const background = '#607d8b';
const accent = '#ef5350';
const primary = '#e4002b';
const secondary = accent;
const success = green;
const active = success;
const info = blue;
const warning = yellow;
const error = red;

const darkBlue = dark;
const primaryColor = primary;
const secondaryColor = secondary;

export const colors = {
    black,
    white,
    dark,
    grey,
    lightGrey,
    mediumGrey,
    blue,
    lightBlue,
    lighterBlue,
    green,
    yellow,
    red,
    inactive,
    background,
    accent,
    primary,
    secondary,
    success,
    active,
    info,
    warning,
    error,
    darkBlue,
    primaryColor,
    secondaryColor,
    textSecondary,
};

export type ColorType =
    | (keyof typeof colors &
          ('textPrimary' | 'textSecondary' | 'error' | 'inherit' | 'primary' | 'secondary' | 'default'))
    | string;

/**
 *
 * @param prop$
 * @param defaultValue
 * @param transform
 * @returns {Function}
 */
export const color =
    (prop$: string | ColorType, defaultValue?: string | ColorType, transform?: PropParser) =>
    (props): any => {
        if (typeof prop$ !== 'undefined' && typeof defaultValue === 'undefined' && typeof transform === 'undefined') {
            return color(prop$, prop$)(props);
        }

        if (props[prop$]) {
            return prop(`theme.colors.${props[prop$]}`, props[prop$], transform)(props);
        }

        return prop(`theme.colors.${defaultValue}`, defaultValue, transform)(props);
    };
